import Marquee from "react-fast-marquee";

const ITEMS = ["Reliable", "Detailed", "Flexible", "Local", "Trusted", "Thorough", "Professional"];

export default function Ribbon() {
  return (
    <div className="bg-primary py-4 border-y border-primary" data-testid="ribbon">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-primary-foreground/90 text-lg font-light tracking-tight px-6">
              {t}
            </span>
            <span className="text-emerald-300">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
